import { z } from 'zod'

export const SimpleTimestampSchema = z.string().regex(/^\d{1,2}:\d{2}$/, 'Invalid timestamp format. Expected MM:SS')
